module.exports = __webpack_public_path__ + "img/value3.a6aa31b7.webp";